"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTelemetryKey = void 0;
var generateTelemetryKey = function (prefix) { return function (key) { return "".concat(prefix, ".").concat(key); }; };
exports.generateTelemetryKey = generateTelemetryKey;
//# sourceMappingURL=generateTelemetryKey.js.map